// const packageUrl = "https://api.txtconnect-ng.txtconnect.net/api/getPackage";
// const baseUrl = "http://62.129.149.151:2025/";

// const baseUrl = "https://api.txtconnect.net/";
const baseUrl = "https://test.txtconnect.net/";
//commented out the test url and added the production url test

const Config = {
  // packageUrl: packageUrl,
  baseUrl: baseUrl,
};

export default Config;
